import React, {ReactNode} from 'react';
import {AlertProps} from '@mui/material/Alert';
import AlertTitle, {AlertTitleProps} from '@mui/material/AlertTitle';
import Button, {ButtonProps} from '@mui/material/Button';
import {Stack} from '@mui/material';

import Icon from 'presentation/icons';
import IconNamesType from 'presentation/icons/IconNamesType';
import {StyledAlert} from './styles';

function AlertInfoRoot(props: AlertProps) {
	return (
		<StyledAlert severity={props.severity || 'info'} {...props}>
			{props.children}
		</StyledAlert>
	);
}

function AlertInfoTitle(props: AlertTitleProps & {title: string}) {
	return <AlertTitle {...props}>{props.title}</AlertTitle>;
}

function AlertDescription({children}: {children: ReactNode}) {
	return <Stack>{children}</Stack>;
}

function AlertAction<C extends React.ElementType>(
	props: ButtonProps<C, {component?: C}> & {$iconName?: IconNamesType},
) {
	return (
		<Button
			href={props.href}
			sx={{alignSelf: 'end', mt: props.mt ?? 2}}
			variant="text"
			endIcon={props.$iconName ? <Icon name={props.$iconName} /> : null}
			{...props}>
			{props.children}
		</Button>
	);
}

export const AlertInfo = {
	Root: AlertInfoRoot,
	Title: AlertInfoTitle,
	Description: AlertDescription,
	Action: AlertAction,
};
